import { useState } from 'react';

import { type DictionaryEnumDto } from '@/api/generated/models/dictionary-enum-dto';
import { useApiClient } from '@/api/util/useApiClient.util';

interface Return {
  enums: DictionaryEnumDto[];
  getEnums: () => Promise<DictionaryEnumDto[]>;
  isFetchingEnums: boolean;
}

export const useGetEnums = (): Return => {
  const { dictionariesApi } = useApiClient();
  const [isFetching, setIsFetching] = useState(false);
  const [response, setResponse] = useState<DictionaryEnumDto[]>([]);

  return {
    enums: response ?? [],
    getEnums: async () => {
      setIsFetching(true);
      try {
        const response = await dictionariesApi.getEnums();
        setResponse(response?.data);
        return response?.data;
      } finally {
        setIsFetching(false);
      }
    },
    isFetchingEnums: isFetching,
  };
};
